import * as React from 'react';

/**
 * @description Turkish icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Turkish } from '@sravni/design-system-icons'
 *
 * <Turkish />
 * ```
 */
const Turkish = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Turkish", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("g", { clipPath: "url(#Turkish__a)" },
        React.createElement("rect", { width: "20", height: "20", rx: "10", fill: "#E30A17" }),
        React.createElement("path", { d: "m14.38 10.492-1.927-.617 1.927-.617v1.234Zm0 0V9.258l1.192-.382.736.999-.736.999-1.192-.382Zm0-3.232 1.191 1.616-1.19.381V7.26Zm3.12 1-1.192 1.615-.736-.999L17.5 8.26Zm0 3.23-1.928-.616.736-.999 1.191 1.616Zm-3.12 1v-1.997l1.191.381-1.19 1.616Zm-3.859 1.663a4.477 4.477 0 0 0 2.274-1.335 5.564 5.564 0 0 1-2.737 2.2 5.658 5.658 0 0 1-3.53.14 5.582 5.582 0 0 1-2.909-1.98A5.448 5.448 0 0 1 2.5 9.876c0-1.192.393-2.35 1.12-3.304a5.582 5.582 0 0 1 2.907-1.978 5.658 5.658 0 0 1 3.531.14 5.564 5.564 0 0 1 2.737 2.199 4.478 4.478 0 0 0-2.274-1.335 4.526 4.526 0 0 0-2.643.17 4.455 4.455 0 0 0-2.081 1.615 4.356 4.356 0 0 0-.786 2.493c0 .89.274 1.76.786 2.493a4.455 4.455 0 0 0 2.08 1.616 4.526 4.526 0 0 0 2.644.169Z", fill: "#fff" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "Turkish__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" }))))));

export { Turkish };
//# sourceMappingURL=Turkish.js.map
